import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { getOemPartners } from "../../redux/actions/almataActions";
import AlmataOemTable from "./common/AlmataOemTable";
import AlmataOemDetailsOffcanvas from "./AlmataOemDetailsOffcanvas";
import "../../styles/InputSheet.css";
import { IoIosArrowForward } from "react-icons/io";

const AlmataOemDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const partner = location.state?.partner;

  const {
    oemPartners = [],
    oemLoading = false,
    oemPagination = {},
  } = useSelector((state) => state.almata || {});
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("active");
  const [viewDetailsOffcanvas, setViewDetailsOffcanvas] = useState({
    isOpen: false,
    partner: null,
  });

  const fetchOemPartners = (page = 1, search = "", status = "active") => {
    if (!partner?._id) return;

    dispatch(
      getOemPartners({
        limit: 10,
        page,
        search,
        status,
        createdBy: partner._id,
      })
    );
  };

  useEffect(() => {
    if (partner?._id) {
      fetchOemPartners(1, "", statusFilter);
    } else {
      navigate("/almata-partners");
    }
  }, [partner, navigate, statusFilter]);

  useEffect(() => {
    if (partner?._id) {
      fetchOemPartners(currentPage, searchTerm, statusFilter);
    }
  }, [currentPage, searchTerm, statusFilter, partner]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    if (value.length === 0 || (value.length > 0 && value[0] !== " ")) {
      setSearchTerm(value);
      setCurrentPage(1);
    } else if (searchTerm.length > 0) {
      setSearchTerm(value);
      setCurrentPage(1);
    }
  };

  const handleTableRowClick = (oemPartner) => {
    navigate("/almataEndUserOfOem", { state: { oemPartner } });
  };

  const handleViewDetails = (partner) => {
    setViewDetailsOffcanvas({ isOpen: true, partner });
  };

  const handleViewDetailsOffcanvasClose = () => {
    setViewDetailsOffcanvas({ isOpen: false, partner: null });
  };

  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div className="form-header">
          <div className="d-flex align-items-center">
            <FiArrowLeft
              className="cursor-pointer me-3"
              style={{ fontSize: "1.5rem" }}
              onClick={() => navigate(-1)}
              title="Go Back"
            />
            <div className="d-flex align-items-center">
              {partner?.logo && (
                <img
                  src={partner.logo}
                  alt={partner.companyName}
                  className="me-3"
                  style={{
                    height: "40px",
                    width: "40px",
                    objectFit: "contain",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    backgroundColor:'#c5c7caff'
                  }}
                />
              )}
              <div>
                <h2 className="mb-0">
                  {partner?.companyName || "OEM Partners"}{" "}
                  <span className="text-secondary">
                    <IoIosArrowForward />
                  </span>
                  OEM Partners
                </h2>
                {partner && (
                  <small className="text-muted">{partner.email}</small>
                )}
              </div>
            </div>
          </div>
        </div>

        <AlmataOemTable
          partners={oemPartners}
          loading={oemLoading}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          currentPage={currentPage}
          pagination={oemPagination}
          setCurrentPage={setCurrentPage}
          handleTableRowClick={handleTableRowClick}
          handleViewDetails={handleViewDetails}
        />
      </div>

      <AlmataOemDetailsOffcanvas
        show={viewDetailsOffcanvas.isOpen}
        onHide={handleViewDetailsOffcanvasClose}
        partner={viewDetailsOffcanvas.partner}
      />
    </div>
  );
};

export default AlmataOemDetails;
